import { Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ModalRef } from '@siemens/element-ng/modal';
import { TranslateService, TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SiIconComponent } from '@siemens/element-ng/icon';
import { map, startWith } from 'rxjs/operators';
import type { ILocation } from '../../../../../../shared/interfaces/ILocation';

@Component({
    selector: 'app-print-location-info',
    templateUrl: './print-location-info.component.html',
    styleUrls: ['./print-location-info.component.scss'],
    imports: [TranslateDirective, TranslatePipe, SiIconComponent]
})
export class PrintLocationInfoComponent {
    private readonly modalRef = inject<ModalRef<unknown, string>>(ModalRef);
    protected readonly translate = inject(TranslateService);

    public readonly data = input<ILocation | null>(null);

    private readonly currentLang = toSignal(
        this.translate.onLangChange.pipe(
            map(event => event.lang),
            startWith(this.translate.currentLang() || this.translate.fallbackLang() || 'en')
        ),
        { initialValue: this.translate.currentLang() || this.translate.fallbackLang() || 'en' }
    );
    public readonly locationdata = computed<ILocation>(() => this.data() ?? ({} as ILocation));
    public readonly buildings = computed(() => {
        const location = this.locationdata();
        return location.buildings?.length ? location.buildings.map(building => building.name).join(', ') : '';
    });
    public readonly countryName = computed(() => {
        const location = this.locationdata();
        return this.currentLang() === 'de' ? (location.country?.name ?? '') : (location.country?.isoName ?? '');
    });

    public print(): void {
        window.print();
    }

    public closeDialog(): void {
        this.modalRef.hide('close');
    }
}
